import { createAsyncThunk } from '@reduxjs/toolkit';
import { getMeRequest, loginRequest } from '../../services/authApi';
import {
    handleRemoveToken,
    ILoginRequest,
    IRespLogin,
    setError,
} from '../../../entities/auth';
import { axiosErrorHandler } from '../../config';

export const authLogin = createAsyncThunk<IRespLogin, ILoginRequest>(
    '@@auth/authLogin',
    async (
        { checkResponse, ...args }: ILoginRequest,
        { rejectWithValue, dispatch }
    ) => {
        try {
            const { data, status } = await loginRequest(args);
            if (checkResponse && status) {
                checkResponse(status, data);
            }
            localStorage.setItem('accessToken', data.token.accessToken);
            localStorage.setItem('refreshToken', data.token.refreshToken);

            return data;
        } catch (err: any) {
            dispatch(setError(err?.response?.data?.message));
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);

export const getMe = createAsyncThunk(
    '@@auth/getMe',
    async (_, { rejectWithValue, dispatch }) => {
        try {
            const { data } = await getMeRequest();

            localStorage.setItem('accessToken', data.token.accessToken);
            localStorage.setItem('refreshToken', data.token.refreshToken);

            return data;
        } catch (err) {
            localStorage.removeItem('@auth');
            dispatch(handleRemoveToken());
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);
